import { render, staticRenderFns } from "./InsuranceCompanyForm.vue?vue&type=template&id=2c6e0256"
import script from "./InsuranceCompanyForm.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports